import React from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap';

const ImportSummaryModal = ({ show, onHide, importSummary, tempData, onFinalize, loading }) => {
  const getStatusClass = (target, found) => {
    return `text-right font-weight-bold ${target === found ? 'text-success' : 'text-danger'}`;
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Import Preview & Validation</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        {importSummary && (
          <div>
            <div className="text-center mb-4">
              <i className={`fas ${importSummary.statementCount === importSummary.importedCount ? 'fa-check-circle text-success' : 'fa-exclamation-circle text-warning'} fa-3x mb-3`}></i>
              <h5 className="mb-1">
                Found {importSummary.importedCount} of {importSummary.statementCount || '?'} transactions
              </h5>
              <p className="text-muted small">These target numbers should appear in the summary table on the first page of your statement.</p>
            </div>

            <Row>
              <Col md={6}>
                <h6 className="small font-weight-bold text-muted text-uppercase mb-3">Comparison Table</h6>
                <table className="table table-sm table-borderless small">
                  <thead>
                    <tr className="border-bottom">
                      <th>Category</th>
                      <th className="text-right">Target</th>
                      <th className="text-right">Found</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Deposits & Additions</td>
                      <td className="text-right">{importSummary.targets.deposits}</td>
                      <td className={getStatusClass(importSummary.targets.deposits, importSummary.categories.deposits)}>{importSummary.categories.deposits}</td>
                    </tr>
                    <tr>
                      <td>Checks Paid</td>
                      <td className="text-right">{importSummary.targets.checks}</td>
                      <td className={getStatusClass(importSummary.targets.checks, importSummary.categories.checks)}>{importSummary.categories.checks}</td>
                    </tr>
                    <tr>
                      <td>ATM & Debit Card</td>
                      <td className="text-right">{importSummary.targets.withdrawals}</td>
                      <td className={getStatusClass(importSummary.targets.withdrawals, importSummary.categories.withdrawals)}>{importSummary.categories.withdrawals}</td>
                    </tr>
                    <tr>
                      <td>Electronic Withdrawals</td>
                      <td className="text-right">{importSummary.targets.electronic}</td>
                      <td className={getStatusClass(importSummary.targets.electronic, importSummary.categories.electronic)}>{importSummary.categories.electronic}</td>
                    </tr>
                    <tr>
                      <td>Fees</td>
                      <td className="text-right">{importSummary.targets.fees}</td>
                      <td className={getStatusClass(importSummary.targets.fees, importSummary.categories.fees)}>{importSummary.categories.fees}</td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col md={6}>
                <div className="bg-light p-3 rounded">
                  <h6 className="small font-weight-bold text-muted text-uppercase mb-2">Statement Summary</h6>
                  <div className="d-flex justify-content-between mb-1 small">
                    <span>Beginning Balance:</span>
                    <span className="font-weight-bold">${importSummary.statementBeginningBalance?.toLocaleString()}</span>
                  </div>
                  <div className="d-flex justify-content-between mb-1 small">
                    <span>Ending Balance:</span>
                    <span className="font-weight-bold">${importSummary.statementEndingBalance?.toLocaleString()}</span>
                  </div>
                  <div className="d-flex justify-content-between border-top pt-2 mt-2">
                    <span className="font-weight-bold">Net Change Found:</span>
                    <span className="font-weight-bold text-primary">${importSummary.importedSum.toLocaleString(undefined, {minimumFractionDigits: 2})}</span>
                  </div>
                </div>
              </Col>
            </Row>

            <div className="mt-4">
              <h6 className="small font-weight-bold text-muted text-uppercase mb-2">Preview (First 5 items)</h6>
              <table className="table table-sm small">
                <tbody>
                  {tempData?.transactions.slice(0, 5).map((tx, idx) => (
                    <tr key={idx}>
                      <td style={{ width: '60px' }}>{new Date(tx.date).toLocaleDateString()}</td>
                      <td className="text-truncate" style={{ maxWidth: '200px' }}>{tx.description}</td>
                      <td className="text-right font-weight-bold">${tx.amount.toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {importSummary.statementCount !== importSummary.importedCount && (
              <div className="alert alert-danger small py-2 mt-3 mb-0">
                <i className="fas fa-exclamation-triangle mr-2"></i>
                <strong>Warning:</strong> The counts do not match the statement. Clicking "Confirm" will import incomplete data.
              </div>
            )}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="bg-light">
        <Button variant="outline-secondary" onClick={onHide}>
          Cancel & Discard
        </Button>
        <Button variant="primary" onClick={onFinalize} disabled={loading}>
          {loading ? 'Finalizing...' : 'Confirm Import'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ImportSummaryModal;
